import { NgModule, ModuleWithProviders } from "@angular/core";
import { CommonModule } from "@angular/common";

@NgModule({
  imports: [CommonModule],
  declarations: [],
  providers: [],
})
export class RequestModule {
  static forRoot(): ModuleWithProviders<RequestModule> {
    return {
      ngModule: RequestModule,
      providers: [],
    };
  }
}
